import { ProductTypeEnum } from '@systemeio/digital-store-shared'
import { BreadcrumbsData } from '@systemeio/ui'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import BreadcrumbsDashboard from 'shared/components/breadcrumbs'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

const StoreBreadcrumbs = () => {
  const { t } = useLocoTranslation()

  const { storeId, itemId, tab, baseStoreHref, BASE_HREF, productType } = useStoreQuery()

  const { data: store } = useStore(storeId)

  const breadcrumbsData: BreadcrumbsData[] = [
    {
      caption: t('dashboard.stores.title'),
      href: BASE_HREF,
      isStatic: true,
    },
    { caption: store?.name || '', href: baseStoreHref },
  ]
  let href = `${baseStoreHref}`
  if (tab) {
    href = href + `?tab=${tab}`
    let caption = ''
    switch (tab) {
      case StoreTabEnum.profile:
        caption = t('dashboard.store.profile.title')
        break
      case StoreTabEnum.link:
        caption = t('dashboard.store.link.title')
        break
      case StoreTabEnum.optin:
        caption = t('dashboard.store.optin.title')
        break
      case StoreTabEnum.theme:
        caption = t('dashboard.store.theme.title')
        break
      case StoreTabEnum.storeSettings:
        caption = t('dashboard.store.edit.title')
        break
      case StoreTabEnum.product:
        switch (productType) {
          case ProductTypeEnum.download:
            caption = t('dashboard.store.product.download.title')
            break
          case ProductTypeEnum.eCourse:
            caption = t('dashboard.store.product.e_course.title')
            break
          case ProductTypeEnum.physicalProduct:
            caption = t('dashboard.store.product.physical_product.title')
        }
    }
    if (itemId) {
      href = href + `&item=${itemId}`
    }
    if (productType) {
      href = href + `&productType=${productType}`
    }

    breadcrumbsData.push({
      caption,
      href: href,
      isStatic: true,
    })
  }

  return <BreadcrumbsDashboard isFetching={!store} data={breadcrumbsData} />
}

export default StoreBreadcrumbs
